import LoadingSpinner from 'tio-employee/components/tas/loading-spinner';

<template>
  <div class="tio-row-center h-screen w-screen">
    <LoadingSpinner />
  </div>
</template>
